import * as echarts from 'echarts'

const install = function (Vue) {
  Vue.prototype.$echarts = echarts
}

export default { install }
